
import {
  Table,
  TableBody,
  TableRow,
} from "@/components/ui/table"
import { useNavigate } from "react-router-dom"
import { getCoreRowModel, useReactTable } from "@tanstack/react-table"
import { Organization } from "@/types/organizations"
import { useSelector, useDispatch } from "react-redux"
import { AppDispatch, RootState } from "@/redux"
import { switchOrganization } from "@/services/organizationService"
import { ColumnMetaData, TableDataProps } from "@/types/types"
import { TableHeaderComponent } from "@/components/custom/Table/TableHeader"
import { EmptyTableRow } from "@/components/custom/Table/EmptyTableRow"
import { CustomTableCell } from "@/components/custom/Table/TableCell"
import { TableCellType } from "@/constants/table/table"

export const DataTable = ({
  columns,
  data,
}: TableDataProps<Organization>
) => {
  const navigate = useNavigate()
  const dispatch: AppDispatch = useDispatch()
  const { token } = useSelector((state: RootState) => state.user)
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  })

  const onSwitchOrganization = (orgId: string) => {
    if (!token) return;
    dispatch(switchOrganization(token, orgId))
      .catch((err: unknown) => { console.log(err); })
  }

  return (
    <div className="rounded-md border w-full">
      <Table>
        <TableHeaderComponent data={data} columns={columns} />
        <TableBody className="text-primary">
          {table.getRowModel().rows.length ? (
            table.getRowModel().rows.map((row) => (
              <TableRow
                key={row.id}
                data-state={row.getIsSelected() && "selected"}
                className="bg-primary-foreground hover:bg-border/5"
              >
                {row.getVisibleCells().map((cell) => (
                  <CustomTableCell
                    key={cell.id}
                    cell={cell}
                    altText={cell.column.id === "action" ? "Login As" : undefined}
                    onClick={() => {
                      if ((cell.column.columnDef.meta as ColumnMetaData)?.type === TableCellType.LINK_BUTTON) {
                        navigate(`/organizations/edit/${cell.getContext().row.original.id}`)
                      } else if (cell.column.id === "action") {
                        onSwitchOrganization(row.original.id)
                      }
                    }}
                  />
                ))}
              </TableRow>
            ))
          ) : (
            <EmptyTableRow numberOfColumns={columns.length} />
          )}
        </TableBody>
      </Table>
    </div>
  )
}
